import { Icon } from '@smg-real-estate/domus';
import { Characteristics } from '@smg-real-estate/hg-rets-schema';

export interface FurnishingField {
  name: keyof Characteristics;
  icon: Icon;
}

export const furnishingFields: FurnishingField[] = [
  { name: 'arePetsAllowed', icon: Icon.Pets },
  { name: 'hasBalcony', icon: Icon.Balcony },
  { name: 'hasGardenShed', icon: Icon.Check },
  { name: 'hasCellar', icon: Icon.Check },
  { name: 'hasAttic', icon: Icon.Check },
  { name: 'hasStoreRoom', icon: Icon.Check },
  { name: 'hasDishwasher', icon: Icon.Check },
  { name: 'hasSteamer', icon: Icon.Check },
  { name: 'hasWashingMachine', icon: Icon.WashingMachine },
  { name: 'hasTumbleDryer', icon: Icon.Check },
  { name: 'hasCableTv', icon: Icon.Check },
  { name: 'hasFireplace', icon: Icon.Check },
  { name: 'hasNiceView', icon: Icon.View },
  { name: 'hasLakeView', icon: Icon.View },
  { name: 'hasMountainView', icon: Icon.View },
  { name: 'isSmokingAllowed', icon: Icon.Check },
  { name: 'isWheelchairAccessible', icon: Icon.Accessible },
  { name: 'isQuiet', icon: Icon.Quiet },
  { name: 'isChildFriendly', icon: Icon.Children },
  { name: 'hasPlayground', icon: Icon.Check },
  { name: 'hasParking', icon: Icon.Parking },
  { name: 'hasGarage', icon: Icon.Garage },
  { name: 'hasDoubleGarage', icon: Icon.Garage },
  { name: 'hasGarageUnderground', icon: Icon.Garage },
  { name: 'hasChargingStation', icon: Icon.ECharging },
  { name: 'hasElevator', icon: Icon.Elevator },
  { name: 'hasSwimmingPool', icon: Icon.Pool },
  { name: 'hasBuildingLawRestrictions', icon: Icon.Check },
  { name: 'hasConnectedBuildingLand', icon: Icon.Check },
  { name: 'isNewBuilding', icon: Icon.NewBuildingApartment },
  { name: 'isRefurbished', icon: Icon.Check },
  { name: 'isPartiallyRefurbished', icon: Icon.Check },
  { name: 'isOldBuilding', icon: Icon.OldBuilding },
  { name: 'isMinergieCertified', icon: Icon.Minergie },
  { name: 'isMinergieGeneral', icon: Icon.Minergie },
  { name: 'isCornerHouse', icon: Icon.Check },
  { name: 'isMiddleHouse', icon: Icon.Check },
  { name: 'hasFlatSharingCommunity', icon: Icon.Check },
  { name: 'isGroundFloorRaised', icon: Icon.Check },
  { name: 'hasPowerSupply', icon: Icon.Check },
  { name: 'hasWaterSupply', icon: Icon.Check },
  { name: 'hasSewageSupply', icon: Icon.Check },
  { name: 'hasGasSupply', icon: Icon.Check },
  { name: 'hasRamp', icon: Icon.Check },
  { name: 'hasLiftingPlatform', icon: Icon.Check },
  { name: 'isUnderRoof', icon: Icon.Check },
];
